import {mapActions, mapState} from "vuex"
import common from "common"
if (LIMI_ENV === "electron") {
  var ipc = window.require("electron").ipcRenderer;
}
export default {
  name: "answerJs",
  data() {
    return {
      currentQuestion:"",//当前题ID
      quickData: {}, //快速问答列表
      standardData: {}, //标准问答列表
      iframeQuickId: "", //课件题id
      questionids: "", //课件题目展示类型
      timeOver: false, //课前测倒计时结束开关
      gameName: "", //游戏类型课件题名称
      iframeUniqueId: "", //课件题;
      iframeAnswerType: "", //课件题来源;
      kejianQuestionSubType: "", //课件题sub_type,
      kejianQuestionType:"",//课件题type
      loadGameSuccess: false, //小游戏加载成功
      timu_message: {},//题目数据
      k_on_off: false, //键盘显示隐藏
      a_on_off: false, //答题显示隐藏
      Keyboard_type: "number", //默认键盘类型
      xuanzeStyleArr: null, //快速问答选择题样式列表
      optionStyleId: 0, //本题的样式
      preClassTestBgImage: '', //课前测背景图片
    }
  },
  computed:{
    ...mapState(["lesson_id","class_id","teacher_id","subject","course_id","class_type"])
  },
   created() {
    // 获取快速问答选择题样式
    this._getXuanZeStyle();
    this.answerEventHub();
    this.getQuestion();
  },
  methods: {
    ...mapActions([
      "getStandardQuestion",
      "getQuickQuestion",
      "sendPreQuestion",
      "getXuanZeStyle",
      "getStandardQuestionExp",
      "getStandardQuestionPlayBack"
    ]),
    /**
     * 获取快速问答选择题样式
     */
    _getXuanZeStyle() {
      this.getXuanZeStyle({}).then(({res, ok})=> {
        if(!ok) return;
        this.xuanzeStyleArr = res;
        if (LIMI_ENV === "electron") {
          res && res.forEach((v)=>{
            ipc.send("loadKeJian", {
              isForce:true,
              url: v.urlStuDefault,
            });
            ipc.send("loadKeJian", {
              isForce:true,
              url: v.urlStuSelected,
            });
            ipc.send("loadKeJian", {
              isForce:true,
              url: v.urlSquareRootBg,
            });
          })
        }
      })
    },
    answerEventHub(){
      this.$root.eventHub.$on("question", (datas, answer_type) => {
        let type = datas.data.type;
        let quick_question_id = datas.data.quick_question_id;
        //  quick_question_id=2;
        let question = null;
        if (type == "1" || type == "6") {
          //标准问答
          question = this.standardData[quick_question_id] || "t";
        } else {
          //快速问答
          question = this.quickData[quick_question_id] || "q";
          // console.log('获取快速问答',question)
        }
        // 发送伪弹幕
        let params = {
          classId: this.class_id,
          quickQuestionId: quick_question_id,
          quickQuestionIndex: datas.data.falseBarrageIndex,
          quickQuestionType: type,
          quickQuestionSubType: question.sub_type || ''
        }
        this.$root.eventHub.$emit('sendFalseBarrage', params, type);
        if (question === "t" || question === "q") {
          console.log('重新请求获取问题列表...')
          this.getQuestion(question, datas, answer_type);
          return;
        }
        //清空答题状态
        if (this.iframeQuickId != "") {
          //主动关闭课件题记录日志
          this.$root.eventHub.$emit("createLog", {
            id: "LMTrackEventWebViewWebCL",
            data: {
              qid: this.iframeQuickId,
              error: "主动关闭",
              kejian_id: 6,
              unque_id: datas.unique_id
            }
          });
          this.iframeQuickId = "";
          this.questionids = "";
          this.timeOver = false;
        }
        this.closeQuestion();
        this.currentQuestion = quick_question_id;
        // 重置课前测背景图
        this.preClassTestBgImage = '';
        if(this.$route.name==="video"){
          this.value = undefined;
          this.k_on_off = false;
          this.showExpressionFlag = false;
        }

        setTimeout(() => {
          if(this.$route.name==="video"){
            if (this.showComments) {
              this.showComments = false; //关闭评价窗口
              this.showToast = false; //关闭Toast窗口
            }
            this.k_on_off = false;
            this.time_on_off = false;
            this.showExpressionFlag = false;
          }
          //type为3是课件题 type:4 小游戏类型课件题 type:5 课前测类型
          //   type=5;
          if (type == "5") {
            let frontTest = common.get("frontTest") || [];
            let item = frontTest.find(v => {
              return v.unique_id == datas.unique_id;
            });
            if (item && item.isDone) {
              return;
            }
            let timeLengh = 0;
            if (datas.data.ots_time) {
              timeLengh =
                datas.data.srv_time +
                question.time_length -
                datas.data.ots_time;
            } else {
              timeLengh =
                datas.data.srv_time +
                question.time_length -
                common.getTemServerTime();
            }
            if (timeLengh > 3) {
              //未超时
              this.countNumber = timeLengh;
            } else {
              //超时
              return;
            }
            // this.questionids = "61265,51604";
            this.questionids =
              question.question_ids +
              "_" +
              datas.data.srv_time +
              "_" +
              question.time_length;
            let qid = quick_question_id - 0;
            this.iframeQuickId = qid;
            this.iframeUniqueId = datas.unique_id;
            this.iframeAnswerType = answer_type;
            this.kejianQuestionSubType = question.sub_type;
            this.preClassTestBgImage =question.bg_img_url || '';
          } else if (type == "3" || type == "4" || (type=="6" && question.qtype=='4')) {
            let qid = quick_question_id - 0;
            this.iframeQuickId = qid;
            this.iframeUniqueId = datas.unique_id;
            this.iframeAnswerType = answer_type;
            this.kejianQuestionSubType = (type=="6" && question.qtype=='4')?"I1":question.sub_type;
            this.kejianQuestionType = type;
            type == "4" && (this.gameName = question.folder);
          } else if (type == "2" || type == "1" || type == "6") {
            /*type ==2 为快速答题   type == "1" 标准问答  type == "6" 可配置标准问答*/
            this.iframeQuickId = "";
            this.questionids = "";
            this.timeOver = false;
            this.gameName = "";
            this.loadGameSuccess = false;
            let desc = {
              quick_question_id,
              answer_type,
              type,
              correctAnswer:datas.data.correct_answer || undefined,
              recv_unique_id: datas.unique_id
            };
            /*获取快速答题，判断是否为选择 1----为选择题*/
            if (question.qtype == 1 || !question.qtype) {
              this.showAnswer("xuanze", question, desc);
            } else if (question.qtype == 2) {
              /*获取快速答题，判断是否为选择 2----为填空题*/
              if(this.$route.name==="video"){
                if (this.grade > 6) {
                  this.Keyboard_type = "all";
                } else {
                  let questionanswer = question.answer || "";
                  if (/[a-z]/i.test(questionanswer)) {
                    this.Keyboard_type = "abc";
                  } else {
                    // if (/[0-9]/.test(question.answer))
                    this.Keyboard_type = "number";
                  }
                }
                this.$refs.keyboard.resetKeyboard();
              }
              this.showAnswer("tiankong", question, desc);
            } else if (question.qtype == 3) {
              //文字开放题
              this.showAnswer("txtquestion", question, desc);
            }
          }
        }, 1100);
      });

      //发送课前测答案
      this.$root.eventHub.$on("sendPreQuestion", data => {
        this.sendPreQuestion({
          lesson_id: this.lesson_id,
          class_id: this.class_id,
          teacher_id: this.teacher_id,
          result: JSON.stringify(data)
        }).then(({ res, ok }) => {
          if (ok) {
            let frontTest = common.get("frontTest") || [];
            frontTest.forEach(item => {
              data.forEach(v => {
                if (item.unique_id == v.unique_id) {
                  item.uploadSuccess = true;
                }
              });
            });
            common.set("frontTest", frontTest);
            // console.log("数据上报成功", res);
            res.coin.forEach(item => {
              item > 0 && this.addCoin && this.addCoin(item, 1000);
            });
          }
        });
      });
    },
    answerOffEventHub(){
      this.$root.eventHub.$off("question");
      this.$root.eventHub.$off("sendPreQuestion");
    },
    //答题区域显示隐藏的方法
    showAnswer(type, question, desc) {
      // 题目样式id
      let option_style_id = 0;
      // 快速问答题样式列表
      let xuanzeStyleArr = this.xuanzeStyleArr;
      let currentQuestionStyle = {};
      // 快速问答题接口返回成功 && 有题目id && 快速问答题列表有此题目（标椎问答题id是在快速问答题列表里匹配不到的）
      if(JSON.stringify(this.quickData) != '{}' && question.id && this.quickData[question.id]) {
        option_style_id = this.quickData[question.id]['option_style_id'];
        let styleIndex = xuanzeStyleArr.findIndex(v => v.id == option_style_id);
        if(xuanzeStyleArr != '' && styleIndex != -1) {
          currentQuestionStyle = xuanzeStyleArr[styleIndex];
        }
      }
      this.$set(this.timu_message, "type", type);
      this.$set(this.timu_message, "desc", desc);
      this.$set(this.timu_message, 'current_question_style', currentQuestionStyle);

      if (type === "xuanze") {
        let options = question.options;
        let arr = [];
        for (let x in options) {
          arr.push(this.Format(options[x]));
        }
        this.$set(this.timu_message, "list", arr);
        // console.log("this.timu_message1", this.timu_message);
      } else if (type === "tiankong") {
        if (question.title) {
          let title_info = question.title.split("[?]");
          let left = title_info[0] ? title_info[0] : "";
          let right = title_info[1] ? title_info[1] : "";
          this.$set(this.timu_message, "left", this.Format(left));
          this.$set(this.timu_message, "right", this.Format(right));
        } else {
          this.$set(this.timu_message, "left", []);
          this.$set(this.timu_message, "right", []);
        }
      }
      this.a_on_off = true;
      if(this.$route.name==="video"){
        this.showComments = false; //关闭评价窗口
        this.showToast = false; //关闭Toast窗口
        this.showExpressionFlag = false;
        this.showClock(question.time_length);
      }
    },
    //获取题目列表
    getQuestion(type, datas, answer_type) {
      let sData = {};
      let qData = {};
      let methodsName = this.$route.name==="playback"?"getStandardQuestionPlayBack":this.class_type==2?"getStandardQuestionExp":"getStandardQuestion";
      //获取标准问答
      if(!type || type === "t"){
        let params = {
          subject: this.subject,
          lesson_id: this.lesson_id
        }
        if(methodsName === 'getStandardQuestion') {
          params.class_id = this.class_id;
          params.class_type = this.class_type;
          params.teacher_id = this.teacher_id;
        }
        this[methodsName](params).then(({ res, ok }) => {
          if (!ok) return;
          res.forEach(function(v, i) {
            sData[v.id] = v;
          });
          this.standardData = sData;
          if(type === "t" && sData[datas.data.quick_question_id]){
            this.$root.eventHub.$emit("question", datas, answer_type);
          }
        });
      }
      //获取快速问答
      if(!type || type === "q"){
        this.getQuickQuestion({
          courseid: this.course_id,
          lessonid: this.lesson_id
        }).then(({ res, ok }) => {

          if (!ok) return;
          res.forEach(function(v, i) {
            qData[v.id] = v;
          });
          this.quickData = qData;
          if(type === "q" && qData[datas.data.quick_question_id]){
            this.$root.eventHub.$emit("question", datas, answer_type);
          }
        });
      }
    },
    //选择填空题显示时数据格式化方法
    Format(message, danmu = false) {
      let resultType = 0;
      let result = [];
      if (message.indexOf("#") > -1 && message.indexOf("/") > -1) {
        let arr = message.split("#");
        arr.forEach((item, index) => {
          if (item != "") {
            if (item.indexOf("/") == -1) {
              result.push({
                type: 0,
                value: [item]
              });
            } else {
              if (item.indexOf("|") > -1) {
                //代分数字
                let str = item.replace("|", "/");
                result.push({
                  type: 1,
                  value: [
                    str.split("/")[1],
                    str.split("/")[2],
                    str.split("/")[0]
                  ]
                });
              } else {
                result.push({
                  type: 1,
                  value: [item.split("/")[0], item.split("/")[1]]
                });
              }
            }
          }
          resultType = 1;
        });
      } else {
        if (message.indexOf("@") > -1) {
          let arr = message.split("@");
          arr.forEach((item, index) => {
            if (index % 2 == 0) {
              result.push({
                type: 0,
                value: [item]
              });
            } else {
              result.push({
                type: 2,
                value: ["", item]
              });
            }
          });
          resultType = 2;
        } else if (message.indexOf("*") > -1) {
          let arr = message.split("*");
          while (arr.length != 0) {
            if (arr.length >= 2) {
              result.push({
                type: 3,
                value: [...arr.splice(0, 2)]
              });
            } else {
              if (arr.length == 1) {
                result.push({
                  type: 3,
                  value: [...arr.splice(0, 1), ""]
                });
                break;
              }
            }
          }
          resultType = 3;
        } else {
          result.push({
            type: 0,
            value: [message]
          });
        }
      }
      if (danmu) {
        if (
          result.length == 1 &&
          result[0].type != 1 &&
          result[0].type != 2 &&
          result[0].type != 3
        ) {
          //非分式
          return result[0];
        } else {
          //分式
          let arr = [];
          result.forEach(item => {
            arr.push(item.value);
          });
          return {
            type: resultType,
            value: arr
          };
        }
      } else {
        return result;
      }
    },
  },
  beforeDestroy() {
    this.answerOffEventHub();
  }
}



// WEBPACK FOOTER //
// ./src/components/bussiness/video/answer/answer.js